import {requests} from 'apis/wrapperAPI';
import {StatusCodes} from 'http-status-codes';

//푸시알림 설정 조회
export const getNotiSetting = async (): Promise<boolean> => {
    const {isSuccess, message, code, result} = await requests.get('/api/setting', true);

    if (isSuccess && (code === StatusCodes.OK || code === StatusCodes.CREATED)) {
        return result.notificationYn;
    }

    throw new Error(message);
};

//푸시알림 설정 업데이트
export const updateNotiSetting = async (notificationYn: boolean): Promise<boolean> => {
    const {isSuccess, message, code, result} = await requests.post('/api/setting', true, {
        notificationYn,
    });

    if (isSuccess && (code === StatusCodes.OK || code === StatusCodes.CREATED)) {
        return result.notificationYn;
    }

    throw new Error(message);
};
